import { render, staticRenderFns } from "./barCharts.vue?vue&type=template&id=3606ff51&scoped=true"
import script from "./barCharts.vue?vue&type=script&lang=js"
export * from "./barCharts.vue?vue&type=script&lang=js"
import style0 from "./barCharts.vue?vue&type=style&index=0&id=3606ff51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3606ff51",
  null
  
)

export default component.exports